import React from "react";
import { PageHeader } from "antd";

import AdminBreadCrumb from "../../components/layout/AdminBreadCrumb";
import HpEnrollmentEntry from "../../components/enrollment/hp/HpEnrollmentEntry";

const HpEnrollment = () => {
  return (
    <div className="inside-main-content">
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="Enrollment - High Performance Or Junior High Performance (Tax Invoice With GST)"
          subTitle=""
          extra={[]}
        ></PageHeader>

        <HpEnrollmentEntry />

      </div>
    </div>
  );
};

export default HpEnrollment;
